export default "__VITE_ASSET__BDyLH_6a__"